export const types = {
  SHOW_IN_PAGE_ERROR: 'ERRORCATCHER/SHOW_IN_PAGE_ERROR',
  CLEAR_IN_PAGE_ERROR: 'ERRORCATCHER/CLEAR_IN_PAGE_ERROR',
};

const initialState = {
  inPageError: null,
};

const ErrorCatcherReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_IN_PAGE_ERROR: {
      if (action.payload) {
        return {
          ...state,
          inPageError: action.payload,
        };
      }
      return state;
    }
    case types.CLEAR_IN_PAGE_ERROR: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};

export const actions = {
  showInPageError: args => ({
    type: types.SHOW_IN_PAGE_ERROR,
    payload: args,
  }),
  clearInPageError: location => ({
    type: types.CLEAR_IN_PAGE_ERROR,
    location,
  }),
};

export default ErrorCatcherReducer;
